import React from 'react';
import { observer } from 'mobx-react';

import { AppRedirect, routeNaming } from '../../../routes';
import { HomeNavbar } from '../../../common/home-navbar';
import { Footer } from '../../../common/footer';
import { SessionStore } from '../../../stores/SessionStore';
import { USER_TYPES } from '../../../models/User';
import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';
import { MyAccountMenu } from '../my-account-menu';
import styles from './MyAccountMenuMobile.css';

const MyAccountMenuMobile = observer(() => {
  if (!SessionStore.loggedIn) {
    return (
      <AppRedirect routeName={routeNaming.HOME} />
    );
  }
  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
  if (!mobileVersion) {
    return (
      <AppRedirect routeName={routeNaming.MY_ACCOUNT} />
    );
  }
  return (
    <div className={styles.container}>
      <HomeNavbar />
      <div className={styles.mainContent}>
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>Mi Cuenta</h1>
          <h2 className={styles.subtitle}>
            <span>Hola, </span>
            {SessionStore.user.type === USER_TYPES.COMPANY ?
              SessionStore.user.fictitiousName :
              SessionStore.user.names}
            !
          </h2>
        </div>
        <MyAccountMenu />
      </div>
      <Footer />
    </div>);
});

export { MyAccountMenuMobile };



// WEBPACK FOOTER //
// ./src/pages/my-account/my-account-menu-mobile/MyAccountMenuMobile.jsx